var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.61148 12.0722C8.70605 11.9388 8.75686 11.7794 8.7569 11.6159V4.43951C8.75668 4.23061 8.67348 4.03035 8.52558 3.88275C8.37769 3.73514 8.17721 3.65227 7.9682 3.65234H0.788704C0.579699 3.65227 0.379216 3.73514 0.231322 3.88275C0.083427 4.03035 0.000223732 4.23061 5.0199e-08 4.43951V11.6151C-3.69113e-05 11.7186 0.0203375 11.8211 0.0599606 11.9168C0.0995836 12.0125 0.157678 12.0994 0.230923 12.1726C0.304169 12.2458 0.39113 12.3038 0.486836 12.3434C0.582543 12.383 0.68512 12.4034 0.788704 12.4034H7.9682C8.0941 12.4036 8.21822 12.3736 8.33015 12.316C8.44207 12.2584 8.53855 12.1748 8.61148 12.0722Z",
    fill: "#0C6B35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0245 8.0293H10.6719V11.9561H17.0245V8.0293Z",
    fill: "#107C41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0245 4.08398H10.6719V8.03035H17.0245V4.08398Z",
    fill: "#21A366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0931 1.06145e-08H10.6719V4.083H17.0245V0.930823C17.0245 0.808574 17.0005 0.687522 16.9536 0.57458C16.9068 0.461638 16.8382 0.359019 16.7517 0.272582C16.6652 0.186145 16.5625 0.117584 16.4495 0.0708144C16.3365 0.0240444 16.2154 -1.84505e-05 16.0931 1.06145e-08Z",
    fill: "#33C481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51992 12.4754V4.05062C9.51992 3.80513 9.42235 3.5697 9.24867 3.39611C9.07499 3.22252 8.83943 3.125 8.59381 3.125H3.96875V3.65324H7.96895C8.17796 3.65317 8.37844 3.73604 8.52634 3.88365C8.67423 4.03125 8.75743 4.23151 8.75766 4.44041V11.616C8.75769 11.7195 8.73732 11.822 8.6977 11.9177C8.65807 12.0134 8.59998 12.1003 8.52673 12.1735C8.45349 12.2467 8.36653 12.3047 8.27082 12.3443C8.17511 12.3839 8.07254 12.4043 7.96895 12.4043H3.96875V13.4007H8.59381C8.83938 13.4007 9.0749 13.3033 9.24857 13.1297C9.42224 12.9562 9.51985 12.7208 9.51992 12.4754Z",
    fill: "#124228"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51992 11.957V12.4771C9.51994 12.5987 9.496 12.7191 9.44947 12.8314C9.40293 12.9437 9.33472 13.0458 9.24872 13.1317C9.16272 13.2177 9.06062 13.2859 8.94825 13.3324C8.83588 13.3789 8.71544 13.4029 8.59381 13.4029H3.96875V15.0701C3.96873 15.1924 3.99281 15.3134 4.0396 15.4264C4.0864 15.5393 4.155 15.6419 4.24148 15.7284C4.32797 15.8148 4.43064 15.8834 4.54364 15.9301C4.65664 15.9769 4.77776 16.001 4.90006 16.001H16.0949C16.2173 16.001 16.3384 15.9769 16.4514 15.9301C16.5644 15.8834 16.6671 15.8148 16.7536 15.7284C16.8401 15.6419 16.9087 15.5393 16.9555 15.4264C17.0023 15.3134 17.0264 15.1924 17.0264 15.0701V11.957H9.52048H9.51992Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6689 8.0293H9.51562V11.9561H10.6689V8.0293Z",
    fill: "#185C37"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6689 4.08398H9.51562V8.03035H10.6689V4.08398Z",
    fill: "#107C41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51992 4.05137V4.083H10.6732V1.06177e-08H4.90006C4.77776 -1.84536e-05 4.65664 0.0240454 4.54364 0.0708171C4.43064 0.117589 4.32797 0.186152 4.24148 0.272591C4.155 0.359029 4.0864 0.46165 4.0396 0.574591C3.99281 0.687532 3.96873 0.80858 3.96875 0.930823V3.12575H8.59381C8.83943 3.12575 9.07499 3.22327 9.24867 3.39686C9.42235 3.57045 9.51992 3.80588 9.51992 4.05137Z",
    fill: "#21A366"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.48762 5.62695H5.28149L4.37662 7.06901L3.47175 5.62695H2.26562L3.75907 8.05311L2.26562 10.4329H3.52913L4.37662 9.05632L5.22397 10.4329H6.48762L4.99417 8.05311L6.48762 5.62695Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 6,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 15.8599L16.0312 12.8496",
    stroke: "#3C50E0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 15.1289L16.0288 15.8609L15.2998 15.1289",
    stroke: "#3C50E0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1895 14.0332H17.4227C17.9315 14.0332 18.3438 14.4455 18.3438 14.9545V16.1755C18.3438 16.683 17.9325 17.0942 17.425 17.0942H14.64C14.1312 17.0942 13.7188 16.6817 13.7188 16.173V14.9517C13.7188 14.4445 14.1302 14.0332 14.6375 14.0332H14.873",
    stroke: "#3C50E0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.a66f5c643de09b93b29a6a94665351ca.svg";
export { ForwardRef as ReactComponent };